module.exports = __webpack_public_path__ + "img/dashboard-4-_1_-1-_1_.0fa5e862.webp";